import React from "react";

export default function AboutMePool() {
  return (
    <div className="pool-container">
      <div className="pool">
        <h2 className="pool_header">About Me</h2>
        <p className="pool_text">
          &nbsp;&nbsp;&nbsp;&nbsp; I'm Chris, a full-stack web developer living
          in Los Angeles, CA. Having graduated with a degree in Mechanical
          Engineering, I have always enjoyed solving difficult technical
          challenges. Designing and building is my passion, making your life
          easier is my goal.
          <br />
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;When I'm not busy studying web development,
          I'm tinkering with Arduino and IoT. Outside of tech, I love sports,
          especially baseball (Let's Go Dodgers!), and traveling.
          <br />
        </p>
        <p className="pool_text pool_text--quote">
          <em>Easy is boring, let's have some fun!</em>
        </p>
      </div>
    </div>
  );
}
